import { Component, Input, OnInit } from '@angular/core';
import { Review } from '../../../models/review.model';
import { TranslateService } from '@ngx-translate/core';
import { OffcanvasHistoryService } from '../../../../services/offcanvas-history.service';

@Component({
    selector: 'app-review-details',
    templateUrl: './review-details.component.html',
    styleUrls: ['./review-details.component.css'],
    standalone: false
})
export class ReviewDetailsComponent implements OnInit {
  @Input() review?: Review;
  @Input() isOffcanvas: boolean = false;

  private questionMap: Map<string, string>;

  constructor(private translateService: TranslateService,
    private offCanvasHistory: OffcanvasHistoryService
  ) {
    this.questionMap = new Map<string, string>([
      [
        'OVERALL_RATING',
        this.translateService.instant('Overall rating of the clinic'),
      ],
      [
        'PROFESSIONALISM',
        this.translateService.instant('Professionalism of the dentist'),
      ],
      [
        'CLARITY_EXPLANATIONS',
        this.translateService.instant(
          'Clarity and availability in explanations'
        ),
      ],
      [
        'RESPECT_TIMES',
        this.translateService.instant('Respect for scheduled times'),
      ],
      [
        'HYGIENIC_CONDITIONS',
        this.translateService.instant(
          'Hygienic conditions of the dental office'
        ),
      ],
      [
        'COST_TRANSPARENCY',
        this.translateService.instant(
          'Clarity and transparency on the cost of treatment'
        ),
      ],
      [
        'TREATMENT_SATISFACTION',
        this.translateService.instant(
          'Satisfaction with the treatment received'
        ),
      ],
      [
        'EASE_OF_REACH',
        this.translateService.instant('Ease of reaching the office'),
      ],
      [
        'APPOINTMENT_MANAGEMENT',
        this.translateService.instant('Experience in managing the appointment'),
      ],
      [
        'WOULD_RETURN',
        this.translateService.instant(
          'Would you return to this dental office?'
        ),
      ],
    ]);
  }

  ngOnInit() { }

  getQuestionKeys(
    ratings?: { [key: string]: { [rating: string]: number } } | undefined
  ): string[] {
    return ratings ? Object.keys(ratings) : [];
  }

  formatLabel(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase());
  }

  getQuestionText(key: string): string {
    return this.questionMap.get(key) || this.formatLabel(key);
  }
  getAverageFromDistribution(distribution: {
    [rating: string]: number;
  }): number {
    if (!distribution) return 0;

    let totalScore = 0;
    let totalCount = 0;

    Object.entries(distribution).forEach(([rating, count]) => {
      const numericRating = Number(rating);
      const numericCount = Number(count);

      totalScore += numericRating * numericCount;
      totalCount += numericCount;
    });

    return totalCount > 0 ? +(totalScore / totalCount).toFixed(2) : 0;
  }

  closeOffcanvas() {
    this.offCanvasHistory.dismiss();
  }


}